/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_third_party_auth = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication providers — Google and Facebook for social login.`)
};

const es_privacy_third_party_auth = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedores de autenticación — Google y Facebook para inicio de sesión social.`)
};

const de_privacy_third_party_auth = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentifizierungsanbieter — Google und Facebook für Social Login.`)
};

const nl_privacy_third_party_auth = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticatieproviders — Google en Facebook voor sociaal inloggen.`)
};

const fr_privacy_third_party_auth = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseurs d’authentification — Google et Facebook pour la connexion sociale.`)
};

const it_privacy_third_party_auth = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornitori di autenticazione — Google e Facebook per il login social.`)
};

const pt_br2_privacy_third_party_auth = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provedores de autenticação — Google e Facebook para login social.`)
};

const pt_privacy_third_party_auth = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fornecedores de autenticação — Google e Facebook para início de sessão social.`)
};

const ja_privacy_third_party_auth = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証プロバイダー — ソーシャルログインのためのGoogleとFacebook。`)
};

const zh_privacy_third_party_auth = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认证提供商 — Google和Facebook用于社交登录。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_third_party_auth = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_third_party_auth(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_third_party_auth", locale)
	if (locale === "en") return en_privacy_third_party_auth(inputs)
	if (locale === "es") return es_privacy_third_party_auth(inputs)
	if (locale === "de") return de_privacy_third_party_auth(inputs)
	if (locale === "nl") return nl_privacy_third_party_auth(inputs)
	if (locale === "fr") return fr_privacy_third_party_auth(inputs)
	if (locale === "it") return it_privacy_third_party_auth(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_third_party_auth(inputs)
	if (locale === "pt") return pt_privacy_third_party_auth(inputs)
	if (locale === "ja") return ja_privacy_third_party_auth(inputs)
	return zh_privacy_third_party_auth(inputs)
};